module.exports = __webpack_public_path__ + "media/images/mstile-310x310-7c6ad5ba91517cf5e4d7e6ad7daac301.png";